import React from 'react';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'rectangular' | 'circular';
  width?: string | number;
  height?: string | number;
  shimmer?: boolean;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  variant = 'rectangular',
  width,
  height,
  shimmer = true,
}) => {
  const baseClasses = 'bg-neutral-800 animate-pulse';
  const shimmerClasses = shimmer
    ? 'relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-neutral-700/50 before:to-transparent'
    : '';

  const variantClasses = {
    text: 'h-4',
    rectangular: '',
    circular: 'rounded-full',
  };

  const style = {
    width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
    height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
  };

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${shimmerClasses} ${className}`}
      style={style}
      aria-busy="true"
      aria-live="polite"
    />
  );
};
